module.exports = __webpack_public_path__ + "img/LK.ddf22f78.jpeg";